"use strict";
exports.__esModule = true;
var LoggingLevel;
(function (LoggingLevel) {
    LoggingLevel[LoggingLevel["Verbose"] = 0] = "Verbose";
    LoggingLevel[LoggingLevel["Information"] = 1] = "Information";
    LoggingLevel[LoggingLevel["Warning"] = 2] = "Warning";
    LoggingLevel[LoggingLevel["Error"] = 3] = "Error";
    LoggingLevel[LoggingLevel["Critical"] = 4] = "Critical";
})(LoggingLevel = exports.LoggingLevel || (exports.LoggingLevel = {}));
var GtlRegistrationOptions = (function () {
    function GtlRegistrationOptions() {
    }
    return GtlRegistrationOptions;
}());
exports.GtlRegistrationOptions = GtlRegistrationOptions;
var GtlDeviceInteractionVectorOptions = (function () {
    function GtlDeviceInteractionVectorOptions() {
        this.PreserveExistingCorrelationVector = false;
    }
    return GtlDeviceInteractionVectorOptions;
}());
exports.GtlDeviceInteractionVectorOptions = GtlDeviceInteractionVectorOptions;
var PageViewData = (function () {
    function PageViewData() {
        this.PageType = undefined;
        this.ProductId = undefined;
    }
    return PageViewData;
}());
exports.PageViewData = PageViewData;
var PageActionData = (function () {
    function PageActionData() {
        this.ContentParentName = undefined;
        this.ContentSlotNumber = undefined;
        this.ContentId = undefined;
        this.ContentDisplayName = undefined;
        this.ContentSource = undefined;
        this.DestinationUri = undefined;
        this.PageType = undefined;
        this.ContentTags = undefined;
    }
    return PageActionData;
}());
exports.PageActionData = PageActionData;
var PageContentData = (function () {
    function PageContentData() {
        this.TargetItemId = undefined;
        this.ContentParentName = undefined;
        this.ContentSlotNumber = undefined;
        this.ContentId = undefined;
        this.ContentDisplayName = undefined;
        this.ContentSource = undefined;
        this.ContentTags = undefined;
    }
    return PageContentData;
}());
exports.PageContentData = PageContentData;
var ContentUpdateData = (function () {
    function ContentUpdateData() {
    }
    return ContentUpdateData;
}());
exports.ContentUpdateData = ContentUpdateData;
var AppActionData = (function () {
    function AppActionData() {
        this.ForegroundPageName = undefined;
        this.ForegroundPageType = undefined;
    }
    return AppActionData;
}());
exports.AppActionData = AppActionData;
var AppLaunchData = (function () {
    function AppLaunchData() {
        this.ActivationUri = undefined;
        this.ActivationIntent = undefined;
        this.ActivationPageName = undefined;
        this.ActivationDuration = undefined;
    }
    return AppLaunchData;
}());
exports.AppLaunchData = AppLaunchData;
var GtlPageType;
(function (GtlPageType) {
    GtlPageType["Browse"] = "Browse";
    GtlPageType["Cart"] = "Cart";
    GtlPageType["Category"] = "Category";
    GtlPageType["Overlay"] = "Overlay";
    GtlPageType["ProductDetails"] = "ProductDetails";
    GtlPageType["Purchase"] = "Purchase";
    GtlPageType["Search"] = "Search";
    GtlPageType["Settings"] = "Settings";
    GtlPageType["WishList"] = "WishList";
})(GtlPageType = exports.GtlPageType || (exports.GtlPageType = {}));
var GtlErrorProperties;
(function (GtlErrorProperties) {
    GtlErrorProperties[GtlErrorProperties["ErrorLevel_Warning"] = 1] = "ErrorLevel_Warning";
    GtlErrorProperties[GtlErrorProperties["ErrorLevel_Verbose"] = 2] = "ErrorLevel_Verbose";
    GtlErrorProperties[GtlErrorProperties["ErrorLevel_ScenarioBlocking"] = 4] = "ErrorLevel_ScenarioBlocking";
    GtlErrorProperties[GtlErrorProperties["ErrorLevel_Fatal"] = 8] = "ErrorLevel_Fatal";
    GtlErrorProperties[GtlErrorProperties["UserVisible"] = 16] = "UserVisible";
    GtlErrorProperties[GtlErrorProperties["UserResolvable"] = 32] = "UserResolvable";
    GtlErrorProperties[GtlErrorProperties["SystemResolvable"] = 64] = "SystemResolvable";
    GtlErrorProperties[GtlErrorProperties["ServiceRelated"] = 128] = "ServiceRelated";
    GtlErrorProperties[GtlErrorProperties["ErrorCode_Type_HRESULT"] = 256] = "ErrorCode_Type_HRESULT";
    GtlErrorProperties[GtlErrorProperties["ErrorCode_Type_Win32"] = 512] = "ErrorCode_Type_Win32";
    GtlErrorProperties[GtlErrorProperties["ErrorCode_Type_NTSTATUS"] = 1024] = "ErrorCode_Type_NTSTATUS";
    GtlErrorProperties[GtlErrorProperties["ErrorCode_Type_HTTP"] = 2048] = "ErrorCode_Type_HTTP";
})(GtlErrorProperties = exports.GtlErrorProperties || (exports.GtlErrorProperties = {}));
var GtlBehaviorType;
(function (GtlBehaviorType) {
    GtlBehaviorType[GtlBehaviorType["UndefinedBehavior"] = 0] = "UndefinedBehavior";
    GtlBehaviorType[GtlBehaviorType["UnknownBehavior"] = 1] = "UnknownBehavior";
    GtlBehaviorType[GtlBehaviorType["Other"] = 2] = "Other";
    GtlBehaviorType[GtlBehaviorType["Select"] = 3] = "Select";
    GtlBehaviorType[GtlBehaviorType["Back"] = 4] = "Back";
    GtlBehaviorType[GtlBehaviorType["AppMenuOpen"] = 5] = "AppMenuOpen";
    GtlBehaviorType[GtlBehaviorType["TabLeft"] = 6] = "TabLeft";
    GtlBehaviorType[GtlBehaviorType["TabRight"] = 7] = "TabRight";
    GtlBehaviorType[GtlBehaviorType["TabUp"] = 8] = "TabUp";
    GtlBehaviorType[GtlBehaviorType["TabDown"] = 9] = "TabDown";
    GtlBehaviorType[GtlBehaviorType["ScrollUp"] = 10] = "ScrollUp";
    GtlBehaviorType[GtlBehaviorType["ScrollDown"] = 11] = "ScrollDown";
    GtlBehaviorType[GtlBehaviorType["ArrowLeft"] = 12] = "ArrowLeft";
    GtlBehaviorType[GtlBehaviorType["ArrowRight"] = 13] = "ArrowRight";
    GtlBehaviorType[GtlBehaviorType["ArrowUp"] = 14] = "ArrowUp";
    GtlBehaviorType[GtlBehaviorType["ArrowDown"] = 15] = "ArrowDown";
    GtlBehaviorType[GtlBehaviorType["ContextualAction"] = 16] = "ContextualAction";
    GtlBehaviorType[GtlBehaviorType["Move"] = 17] = "Move";
    GtlBehaviorType[GtlBehaviorType["Delete"] = 18] = "Delete";
    GtlBehaviorType[GtlBehaviorType["Edit"] = 19] = "Edit";
    GtlBehaviorType[GtlBehaviorType["Like"] = 20] = "Like";
    GtlBehaviorType[GtlBehaviorType["Dislike"] = 21] = "Dislike";
    GtlBehaviorType[GtlBehaviorType["Confirm"] = 22] = "Confirm";
    GtlBehaviorType[GtlBehaviorType["Dismiss"] = 23] = "Dismiss";
    GtlBehaviorType[GtlBehaviorType["Search"] = 24] = "Search";
    GtlBehaviorType[GtlBehaviorType["DropDownOpen"] = 25] = "DropDownOpen";
    GtlBehaviorType[GtlBehaviorType["DropDownClose"] = 26] = "DropDownClose";
    GtlBehaviorType[GtlBehaviorType["MarkRead"] = 27] = "MarkRead";
    GtlBehaviorType[GtlBehaviorType["ViewProfile"] = 28] = "ViewProfile";
    GtlBehaviorType[GtlBehaviorType["DismissAll"] = 29] = "DismissAll";
    GtlBehaviorType[GtlBehaviorType["CaptureOptions"] = 30] = "CaptureOptions";
    GtlBehaviorType[GtlBehaviorType["RecentCaptures"] = 31] = "RecentCaptures";
    GtlBehaviorType[GtlBehaviorType["MouseLeftClick"] = 32] = "MouseLeftClick";
    GtlBehaviorType[GtlBehaviorType["MouseRightClick"] = 33] = "MouseRightClick";
    GtlBehaviorType[GtlBehaviorType["MouseScroll"] = 34] = "MouseScroll";
    GtlBehaviorType[GtlBehaviorType["Hotkey"] = 35] = "Hotkey";
    GtlBehaviorType[GtlBehaviorType["AppNotification"] = 36] = "AppNotification";
    GtlBehaviorType[GtlBehaviorType["BackgroundAppAction"] = 37] = "BackgroundAppAction";
    GtlBehaviorType[GtlBehaviorType["ScenarioFailed"] = 38] = "ScenarioFailed";
    GtlBehaviorType[GtlBehaviorType["Cancel"] = 39] = "Cancel";
    GtlBehaviorType[GtlBehaviorType["Close"] = 40] = "Close";
    GtlBehaviorType[GtlBehaviorType["UserAction"] = 41] = "UserAction";
    GtlBehaviorType[GtlBehaviorType["Shortcut"] = 42] = "Shortcut";
    GtlBehaviorType[GtlBehaviorType["Submit"] = 43] = "Submit";
})(GtlBehaviorType = exports.GtlBehaviorType || (exports.GtlBehaviorType = {}));
var GtlAppLaunchType;
(function (GtlAppLaunchType) {
    GtlAppLaunchType[GtlAppLaunchType["Launch"] = 0] = "Launch";
    GtlAppLaunchType[GtlAppLaunchType["Resume"] = 1] = "Resume";
})(GtlAppLaunchType = exports.GtlAppLaunchType || (exports.GtlAppLaunchType = {}));
var GtlGroupIdType;
(function (GtlGroupIdType) {
    GtlGroupIdType[GtlGroupIdType["OptionalDiagnostic"] = 1] = "OptionalDiagnostic";
    GtlGroupIdType[GtlGroupIdType["CoreRequired"] = 2] = "CoreRequired";
    GtlGroupIdType[GtlGroupIdType["Functional"] = 4] = "Functional";
})(GtlGroupIdType = exports.GtlGroupIdType || (exports.GtlGroupIdType = {}));
var EventKeyword;
(function (EventKeyword) {
    EventKeyword[EventKeyword["Telemetry"] = 35184372088832] = "Telemetry";
    EventKeyword[EventKeyword["Measure"] = 70368744177664] = "Measure";
    EventKeyword[EventKeyword["Critical"] = 140737488355328] = "Critical";
    EventKeyword[EventKeyword["DeviceInteractionData"] = 8796093022208] = "DeviceInteractionData";
})(EventKeyword = exports.EventKeyword || (exports.EventKeyword = {}));
var PrivacyTag;
(function (PrivacyTag) {
    PrivacyTag[PrivacyTag["None"] = 0] = "None";
    PrivacyTag[PrivacyTag["Account"] = 1] = "Account";
    PrivacyTag[PrivacyTag["BrowsingHistory"] = 2] = "BrowsingHistory";
    PrivacyTag[PrivacyTag["CloudServiceProvider"] = 4] = "CloudServiceProvider";
    PrivacyTag[PrivacyTag["CommuteAndTravel"] = 8] = "CommuteAndTravel";
    PrivacyTag[PrivacyTag["CompensationAndBenefits"] = 16] = "CompensationAndBenefits";
    PrivacyTag[PrivacyTag["ContentConsumption"] = 32] = "ContentConsumption";
    PrivacyTag[PrivacyTag["Credentials"] = 64] = "Credentials";
    PrivacyTag[PrivacyTag["CustomerContact"] = 128] = "CustomerContact";
    PrivacyTag[PrivacyTag["CustomerContactList"] = 256] = "CustomerContactList";
    PrivacyTag[PrivacyTag["CustomerContent"] = 512] = "CustomerContent";
    PrivacyTag[PrivacyTag["DemographicInformation"] = 1024] = "DemographicInformation";
    PrivacyTag[PrivacyTag["DeviceConnectivityAndConfiguration"] = 2048] = "DeviceConnectivityAndConfiguration";
    PrivacyTag[PrivacyTag["EnvironmentalSensor"] = 4096] = "EnvironmentalSensor";
    PrivacyTag[PrivacyTag["EUII"] = 8192] = "EUII";
    PrivacyTag[PrivacyTag["FeedbackAndRatings"] = 16384] = "FeedbackAndRatings";
    PrivacyTag[PrivacyTag["FinancialAccountingAndRecords"] = 32768] = "FinancialAccountingAndRecords";
    PrivacyTag[PrivacyTag["FitnessAndActivity"] = 65536] = "FitnessAndActivity";
    PrivacyTag[PrivacyTag["InkingTypingAndSpeechUtterance"] = 131072] = "InkingTypingAndSpeechUtterance";
    PrivacyTag[PrivacyTag["InterestsAndFavorites"] = 262144] = "InterestsAndFavorites";
    PrivacyTag[PrivacyTag["LearningAndDevelopment"] = 524288] = "LearningAndDevelopment";
    PrivacyTag[PrivacyTag["LicensingAndPurchase"] = 1048576] = "LicensingAndPurchase";
    PrivacyTag[PrivacyTag["MicrosoftCommunications"] = 2097152] = "MicrosoftCommunications";
    PrivacyTag[PrivacyTag["PaymentInstrument"] = 4194304] = "PaymentInstrument";
    PrivacyTag[PrivacyTag["PreciseUserLocation"] = 8388608] = "PreciseUserLocation";
    PrivacyTag[PrivacyTag["ProductAndServicePerformance"] = 16777216] = "ProductAndServicePerformance";
    PrivacyTag[PrivacyTag["ProductAndServiceUsage"] = 33554432] = "ProductAndServiceUsage";
    PrivacyTag[PrivacyTag["ProfessionalAndPersonalProfile"] = 67108864] = "ProfessionalAndPersonalProfile";
    PrivacyTag[PrivacyTag["PublicPersonal"] = 134217728] = "PublicPersonal";
    PrivacyTag[PrivacyTag["Recruitment"] = 268435456] = "Recruitment";
    PrivacyTag[PrivacyTag["SearchRequestsAndQuery"] = 536870912] = "SearchRequestsAndQuery";
    PrivacyTag[PrivacyTag["Social"] = 1073741824] = "Social";
    PrivacyTag[PrivacyTag["SoftwareSetupAndInventory"] = 2147483648] = "SoftwareSetupAndInventory";
    PrivacyTag[PrivacyTag["Support"] = 4294967296] = "Support";
    PrivacyTag[PrivacyTag["SupportContent"] = 8589934592] = "SupportContent";
    PrivacyTag[PrivacyTag["SupportInteraction"] = 17179869184] = "SupportInteraction";
    PrivacyTag[PrivacyTag["WorkContracts"] = 34359738368] = "WorkContracts";
    PrivacyTag[PrivacyTag["WorkplaceInteractions"] = 68719476736] = "WorkplaceInteractions";
    PrivacyTag[PrivacyTag["WorkProfile"] = 137438953472] = "WorkProfile";
    PrivacyTag[PrivacyTag["WorkRecognition"] = 274877906944] = "WorkRecognition";
    PrivacyTag[PrivacyTag["WorkTime"] = 549755813888] = "WorkTime";
})(PrivacyTag = exports.PrivacyTag || (exports.PrivacyTag = {}));
var GtlEventType;
(function (GtlEventType) {
    GtlEventType["SessionStarted"] = "SessionStarted";
    GtlEventType["SessionStopped"] = "SessionStopped";
    GtlEventType["Summary"] = "Summary";
    GtlEventType["ActiveUserUpdated"] = "ActiveUserUpdated";
    GtlEventType["PageView"] = "PageView";
    GtlEventType["PageAction"] = "PageAction";
    GtlEventType["ContentUpdate"] = "ContentUpdate";
    GtlEventType["Error"] = "Error";
    GtlEventType["RelatedCv"] = "RelatedCv";
    GtlEventType["AppAction"] = "AppAction";
    GtlEventType["AppLaunch"] = "AppLaunch";
    GtlEventType["Undefined"] = "Undefined";
})(GtlEventType = exports.GtlEventType || (exports.GtlEventType = {}));
//# sourceMappingURL=Types.js.map